import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Cart.css';

const Cart = () => {
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const navigate = useNavigate();

  if (cartItems.length === 0) {
    return (
      <div className="empty-cart">
        <div className="container">
          <div className="empty-cart-content">
            <h2 className="empty-cart-title">Your Cart is Empty</h2>
            <p className="empty-cart-subtitle">カートは空です</p>
            <p className="empty-cart-text">
              Discover our premium collection and add some items to your cart.
            </p>
            <Link to="/shop" className="shop-now-button">
              Continue Shopping
              <span className="button-kanji">ショッピングを続ける</span>
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart">
      <div className="container">
        <div className="cart-header">
          <h1 className="cart-title">
            Shopping Cart
            <span className="title-kanji">ショッピングカート</span>
          </h1>
          <p className="cart-count">{cartItems.length} {cartItems.length === 1 ? 'item' : 'items'}</p>
        </div>

        <div className="cart-content">
          <div className="cart-items">
            {cartItems.map((item) => (
              <div key={`${item.id}-${item.size}`} className="cart-item">
                <Link to={`/product/${item.id}`} className="item-image">
                  <img src={item.image} alt={item.name} />
                </Link>

                <div className="item-details">
                  <Link to={`/product/${item.id}`} className="item-name">
                    {item.name}
                  </Link>
                  <p className="item-name-jp">{item.nameJp}</p>
                  <div className="item-meta">
                    <span className="item-size">Size: {item.size}</span>
                    <span className="item-category">{item.category}</span>
                  </div>
                </div>

                <div className="item-quantity">
                  <label className="quantity-label">Quantity</label>
                  <div className="quantity-controls">
                    <button
                      className="quantity-button"
                      onClick={() => updateQuantity(item.id, item.size, item.quantity - 1)}
                    >
                      -
                    </button>
                    <span className="quantity-value">{item.quantity}</span>
                    <button
                      className="quantity-button"
                      onClick={() => updateQuantity(item.id, item.size, item.quantity + 1)}
                    >
                      +
                    </button>
                  </div>
                </div>

                <div className="item-price">
                  <span className="price-label">Price</span>
                  <span className="price-value">DA{(item.price * item.quantity).toLocaleString()}</span>
                </div>

                <button
                  className="remove-button"
                  onClick={() => removeFromCart(item.id, item.size)}
                  title="Remove item"
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <h3 className="summary-title">Order Summary</h3>
            
            <div className="summary-details">
              <div className="summary-row">
                <span>Subtotal</span>
                <span>DA{getCartTotal().toLocaleString()}</span>
              </div>
              <div className="summary-row">
                <span>Shipping</span>
                <span className="free-shipping">Free</span>
              </div>
              <div className="summary-row">
                <span>Tax</span>
                <span>Calculated at checkout</span>
              </div>
            </div>

            <div className="summary-total">
              <span>Total</span>
              <span className="total-amount">DA{getCartTotal().toLocaleString()}</span>
            </div>

            <button
              className="checkout-button"
              onClick={() => navigate('/checkout')}
            >
              Proceed to Checkout
              <span className="button-kanji">チェックアウトへ</span>
            </button>

            <Link to="/shop" className="continue-shopping">
              ← Continue Shopping
            </Link>

            <div className="summary-info">
              <p>Free shipping on all orders</p>
              <p>Secure checkout</p>
              <p>Easy returns within 2 days</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
